import React, { useState, useEffect, useMemo } from 'react'
import Grid from '@mui/material/Grid2'
import { Button, Box, Typography, Stack, Pagination } from '@mui/material'
import { styled } from '@mui/material/styles'
import Tab from '@mui/material/Tab'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'

import Api from '../../../Api/Api'
import { MantineReactTable, useMantineReactTable } from 'mantine-react-table'
// import ExportToExcel from '../../../Components/ExportToExcel'
import LoadingButton from '@mui/lab/LoadingButton'
import excel_img from '../../../asset/excel_img.png'
import * as XLSX from 'xlsx'
import secureLocalStorage from 'react-secure-storage'
import 'dayjs/locale/ko'
import dayjs from 'dayjs'

const MyPagination = styled(Pagination)({
  '& .Mui-selected': {
    border: '1px solid',
    borderImageSource:
      'linear-gradient(166.93deg, #AFAFAF 3.24%, rgba(96, 96, 96, 0) 96.43%),linear-gradient(317.92deg, rgba(255, 255, 255, 0.6) 1.48%, rgba(0, 0, 0, 0) 67.95%)',
    backgroundColor:
      'linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14)),linear-gradient(321.23deg, rgba(191, 191, 191, 0.062) 5.98%, rgba(0, 0, 0, 0) 66.28%)',
    color: '#ffffff',
  },
  '& .MuiPaginationItem-root': {
    color: '#ffffff',
  },
  //There has a lot of Global classes. you have to use it according to your requirement
  //Some classes are MuiPaginationItem-root, MuiPaginationItem-page and Mui-selected
})
const styles1 = {
  grid1: {
    padding: 4,
    background: '#2C2D33',
    borderRadius: '10px',
    border: '1px solid #afafaf',
    borderImageSlice: 1,
    borderImage:
      'linear-gradient(166.93deg, #afafaf 3.24%, rgba(96, 96, 96, 0) 96.43%),linear-gradient(317.92deg, rgba(255, 255, 255, 0.6) 1.48%, rgba(0, 0, 0, 0) 37.95%)',
  },
  Typography1: {
    color: '#ffffff',
    fontFamily: 'Noto Sans KR',
    fontSize: '22px',
    fontWeight: 700,
    lineHeight: '28.96px',
    textAlign: 'center',
    textUnderlinePosition: 'from-font',
    textDecorationSkipInk: 'none',
  },
  TableCell1: {
    color: '#CCCCCC',
    borderBottom: '1px solid #CCCCCC',
    background:
      'linear-gradient(to bottom, rgba(0, 0, 0,0.70), rgba(0, 0, 0)),linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14))',
  },

  TableCellHeader1: { background: '#2F2E41', color: '#ffffff', borderBottom: '1px solid #CCCCCC' },
}
//tab in tab
const StyledTab = styled(Tab)(({ theme }) => ({
  color: '#807F88',
  fontFamily: 'Noto Sans KR',
  fontSize: '12px',
  height: 30,
  fontWeight: 500,
  lineHeight: '28.96px',
  textAlign: 'left',
  textUnderlinePosition: 'from-font',
  textDecorationSkipInk: 'none',
  borderRadius: '5px 5px 0px 0px',
  borderTop: '0.1px solid #454546',
  borderRight: '0.1px solid #454546',
  borderLeft: '0.1px solid #454546',
  background: '#AFAFAF',
  '&.Mui-selected': {
    fontWeight: 700,
    color: '#FFFFFF',
    borderRadius: '5px 5px 0px 0px',
    background: 'linear-gradient(180deg, #7940CF 0%, #5921CB 100%)',
    // borderBottom: '7px solid',
    // // border색깔 시작
    // borderImage: 'linear-gradient(89.58deg, #628eff 10%, #8740cd 57.32%, #580475 99.08%)',
    // borderImageSlice: 1,
    // // border색깔 끝
  },
  '&:hover': {
    fontWeight: 700,
    color: '#FFFFFF',
  },
}))

export default function LogManage() {
  const [pageNumber, setPageNumber] = useState(1)
  const [pageNumberTotal, setPageNumberTotal] = useState(10)
  const [pageNumber2, setPageNumber2] = useState(1)
  const [pageNumberTotal2, setPageNumberTotal2] = useState(10)
  const [pageNumber3, setPageNumber3] = useState(1)
  const [pageNumberTotal3, setPageNumberTotal3] = useState(10)
  const [pageNumber4, setPageNumber4] = useState(1)
  const [pageNumberTotal4, setPageNumberTotal4] = useState(10)

  const [logList, setLogList] = useState([])
  const [logList2, setLogList2] = useState([])
  const [logList3, setLogList3] = useState([])
  const [logList4, setLogList4] = useState([])
  const [loadingFlagExcel, setLoadingFlagExcel] = useState(false)

  const [pg, setpg] = React.useState(0)
  const [rpg, setrpg] = React.useState(5)

  const columns = useMemo(
    () => [
      {
        accessorKey: 'udt',
        header: '날짜',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'rst',
        Cell: ({ cell }) =>
          cell.getValue() === 1
            ? '성공'
            : cell.getValue() === 2
              ? '실패'
              : cell.getValue() === 3
                ? '시작'
                : cell.getValue() === 4
                  ? '성공(종료)'
                  : cell.getValue() === 5
                    ? '실패(종료)'
                    : '',
        header: '결과',
        size: 80,
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'lv',
        Cell: ({ cell }) =>
          cell.getValue() === 1
            ? 'INFO'
            : cell.getValue() === 2
              ? 'WARN'
              : cell.getValue() === 3
                ? 'DANGER'
                : cell.getValue() === 4
                  ? 'CRIT'
                  : '',
        header: '위험도',
        size: 80,
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'sys',
        header: '시스템',
        size: 80,
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'fc',
        header: '기능',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'di',
        header: '관리자',
        size: 100,
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'description',
        header: '내용',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
    ],
    []
  )
  const columns2 = useMemo(
    () => [
      {
        accessorKey: 'udt',
        header: '날짜',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'rst',
        Cell: ({ cell }) =>
          cell.getValue() === 1
            ? '성공'
            : cell.getValue() === 2
              ? '실패'
              : cell.getValue() === 3
                ? '시작'
                : cell.getValue() === 4
                  ? '성공(종료)'
                  : cell.getValue() === 5
                    ? '실패(종료)'
                    : '',
        header: '결과',
        size: 80,
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'lv',
        Cell: ({ cell }) =>
          cell.getValue() === 1
            ? 'INFO'
            : cell.getValue() === 2
              ? 'WARN'
              : cell.getValue() === 3
                ? 'DANGER'
                : cell.getValue() === 4
                  ? 'CRIT'
                  : '',
        header: '위험도',
        size: 80,
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'sys',
        header: '시스템',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'fc',
        header: '기능',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'di',
        header: '데이터전송장비',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'description',
        header: '내용',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
    ],
    []
  )

  const columns3 = useMemo(
    () => [
      {
        accessorKey: 'audit',
        header: '계정',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'sys',
        header: '접속시스템',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'cdt',
        header: '접속시간',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'edt',
        header: '종료시간',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'tm',
        header: '사용시간(시,분,초)',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
    ],
    []
  )

  const columns4 = useMemo(
    () => [
      {
        accessorKey: 'audit',
        header: '계정',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'sys',
        header: '접속시스템',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'fc',
        header: '기능',
        Cell: ({ cell }) => (cell.getValue() === 1000 ? '접속정보' : cell.getValue() === 2000 ? '파일다운로드' : ''),
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'cdt',
        header: '감사발생시간',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'tg',
        header: '감사발생위치(기본파일이름)',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
    ],
    []
  )

  const table = useMantineReactTable({
    columns: columns,
    data: logList, //must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
    getRowId: (row) => row.ji,
    // onRowSelectionChange: setRowSelection,
    // state: { rowSelection },
    // selectDisplayMode: 'checkbox',
    enableRowSelection: false,
    enableMultiRowSelection: false,
    enableColumnActions: false,
    enableColumnFilters: false,
    enablePagination: false,
    enableSorting: false,
    enableFullScreenToggle: false,
    // paginationDisplayMode: 'pages',
    initialState: { density: 'sm' },
    mantineTableHeadCellProps: {
      sx: { background: '#2F2E41' },
      align: 'start',
      // '.mantine-TableHeadCell-Content-Wrapper': {
      //   color: '#ffffff',
      // },
      ' .mantine-TableHeadCell-Content-Labels .mantine-TableHeadCell-Content-Wrapper': {
        color: '#ffffff',
      },
    },
    mantineTableBodyCellProps: {
      sx: {
        color: '#CCCCCC',
        background:
          'linear-gradient(to bottom, rgba(0, 0, 0,0.70), rgba(0, 0, 0)),linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14))',
      },
      align: 'start',
    },
    mantineDetailPanelProps: {
      sx: {
        color: '#ffffff',
        background:
          'linear-gradient(to right, rgba(0, 0, 0,0.70), rgba(0, 0, 0)),linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14))',
      },
    },
    mantineTopToolbarProps: {
      sx: {
        color: '#ffffff',
        background: '#21222D',
        // mantine-Stack-root
        '.mantine-Alert-root': {
          color: '#ffffff',
          background: '#21222D',
        },
        '.mantine-Stack-root': {
          color: '#ffffff',
          background: '#21222D',
        },
      },
    },
    mantineBottomToolbarProps: {
      sx: {
        background: '#21222D',
        '.mantine-Input-input': {
          color: '#ffffff',
          background: '#21222D',
          borderColor: '#CCCCCC',
        },
        '.mantine-InputWrapper-label': {
          color: '#ffffff',
          background: '#21222D',
          borderColor: '#CCCCCC',
        },
        '& .mantine-Text-root': {
          color: '#ffffff',
        },
      },
    },
    mantinePaginationProps: {
      sx: {
        background: '#21222D',
        '.mantine-UnstyledButton-root': {
          color: '#ffffff',
          background: '#21222D',
          borderColor: '#CCCCCC',
        },
      },
    },
  })

  const table2 = useMantineReactTable({
    columns: columns2,
    data: logList2, //must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
    getRowId: (row) => row.ji,
    // onRowSelectionChange: setRowSelection,
    // state: { rowSelection },
    // selectDisplayMode: 'checkbox',
    enableRowSelection: false,
    enableMultiRowSelection: false,
    enableColumnActions: false,
    enableColumnFilters: false,
    enablePagination: false,
    enableSorting: false,
    enableFullScreenToggle: false,
    // paginationDisplayMode: 'pages',
    initialState: { density: 'sm' },
    mantineTableHeadCellProps: {
      sx: { background: '#2F2E41' },
      align: 'start',
      // '.mantine-TableHeadCell-Content-Wrapper': {
      //   color: '#ffffff',
      // },
      ' .mantine-TableHeadCell-Content-Labels .mantine-TableHeadCell-Content-Wrapper': {
        color: '#ffffff',
      },
    },
    mantineTableBodyCellProps: {
      sx: {
        color: '#CCCCCC',
        background:
          'linear-gradient(to bottom, rgba(0, 0, 0,0.70), rgba(0, 0, 0)),linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14))',
      },
      align: 'start',
    },
    mantineDetailPanelProps: {
      sx: {
        color: '#ffffff',
        background:
          'linear-gradient(to right, rgba(0, 0, 0,0.70), rgba(0, 0, 0)),linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14))',
      },
    },
    mantineTopToolbarProps: {
      sx: {
        color: '#ffffff',
        background: '#21222D',
        // mantine-Stack-root
        '.mantine-Alert-root': {
          color: '#ffffff',
          background: '#21222D',
        },
        '.mantine-Stack-root': {
          color: '#ffffff',
          background: '#21222D',
        },
      },
    },
    mantineBottomToolbarProps: {
      sx: {
        background: '#21222D',
        '.mantine-Input-input': {
          color: '#ffffff',
          background: '#21222D',
          borderColor: '#CCCCCC',
        },
        '.mantine-InputWrapper-label': {
          color: '#ffffff',
          background: '#21222D',
          borderColor: '#CCCCCC',
        },
        '& .mantine-Text-root': {
          color: '#ffffff',
        },
      },
    },
    mantinePaginationProps: {
      sx: {
        background: '#21222D',
        '.mantine-UnstyledButton-root': {
          color: '#ffffff',
          background: '#21222D',
          borderColor: '#CCCCCC',
        },
      },
    },
  })
  const table3 = useMantineReactTable({
    columns: columns3,
    data: logList3, //must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
    getRowId: (row) => row.ji,
    // onRowSelectionChange: setRowSelection,
    // state: { rowSelection },
    // selectDisplayMode: 'checkbox',
    enableRowSelection: false,
    enableMultiRowSelection: false,
    enableColumnActions: false,
    enableColumnFilters: false,
    enablePagination: false,
    enableSorting: false,
    enableFullScreenToggle: false,
    // paginationDisplayMode: 'pages',
    initialState: { density: 'sm' },
    mantineTableHeadCellProps: {
      sx: { background: '#2F2E41' },
      align: 'start',
      // '.mantine-TableHeadCell-Content-Wrapper': {
      //   color: '#ffffff',
      // },
      ' .mantine-TableHeadCell-Content-Labels .mantine-TableHeadCell-Content-Wrapper': {
        color: '#ffffff',
      },
    },
    mantineTableBodyCellProps: {
      sx: {
        color: '#CCCCCC',
        background:
          'linear-gradient(to bottom, rgba(0, 0, 0,0.70), rgba(0, 0, 0)),linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14))',
      },
      align: 'start',
    },
    mantineDetailPanelProps: {
      sx: {
        color: '#ffffff',
        background:
          'linear-gradient(to right, rgba(0, 0, 0,0.70), rgba(0, 0, 0)),linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14))',
      },
    },
    mantineTopToolbarProps: {
      sx: {
        color: '#ffffff',
        background: '#21222D',
        // mantine-Stack-root
        '.mantine-Alert-root': {
          color: '#ffffff',
          background: '#21222D',
        },
        '.mantine-Stack-root': {
          color: '#ffffff',
          background: '#21222D',
        },
      },
    },
    mantineBottomToolbarProps: {
      sx: {
        background: '#21222D',
        '.mantine-Input-input': {
          color: '#ffffff',
          background: '#21222D',
          borderColor: '#CCCCCC',
        },
        '.mantine-InputWrapper-label': {
          color: '#ffffff',
          background: '#21222D',
          borderColor: '#CCCCCC',
        },
        '& .mantine-Text-root': {
          color: '#ffffff',
        },
      },
    },
    mantinePaginationProps: {
      sx: {
        background: '#21222D',
        '.mantine-UnstyledButton-root': {
          color: '#ffffff',
          background: '#21222D',
          borderColor: '#CCCCCC',
        },
      },
    },
  })

  const table4 = useMantineReactTable({
    columns: columns4,
    data: logList4, //must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
    getRowId: (row) => row.ji,
    // onRowSelectionChange: setRowSelection,
    // state: { rowSelection },
    // selectDisplayMode: 'checkbox',
    enableRowSelection: false,
    enableMultiRowSelection: false,
    enableColumnActions: false,
    enableColumnFilters: false,
    enablePagination: false,
    enableSorting: false,
    enableFullScreenToggle: false,
    // paginationDisplayMode: 'pages',
    initialState: { density: 'sm' },
    mantineTableHeadCellProps: {
      sx: { background: '#2F2E41' },
      align: 'start',
      // '.mantine-TableHeadCell-Content-Wrapper': {
      //   color: '#ffffff',
      // },
      ' .mantine-TableHeadCell-Content-Labels .mantine-TableHeadCell-Content-Wrapper': {
        color: '#ffffff',
      },
    },
    mantineTableBodyCellProps: {
      sx: {
        color: '#CCCCCC',
        background:
          'linear-gradient(to bottom, rgba(0, 0, 0,0.70), rgba(0, 0, 0)),linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14))',
      },
      align: 'start',
    },
    mantineDetailPanelProps: {
      sx: {
        color: '#ffffff',
        background:
          'linear-gradient(to right, rgba(0, 0, 0,0.70), rgba(0, 0, 0)),linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14))',
      },
    },
    mantineTopToolbarProps: {
      sx: {
        color: '#ffffff',
        background: '#21222D',
        // mantine-Stack-root
        '.mantine-Alert-root': {
          color: '#ffffff',
          background: '#21222D',
        },
        '.mantine-Stack-root': {
          color: '#ffffff',
          background: '#21222D',
        },
      },
    },
    mantineBottomToolbarProps: {
      sx: {
        background: '#21222D',
        '.mantine-Input-input': {
          color: '#ffffff',
          background: '#21222D',
          borderColor: '#CCCCCC',
        },
        '.mantine-InputWrapper-label': {
          color: '#ffffff',
          background: '#21222D',
          borderColor: '#CCCCCC',
        },
        '& .mantine-Text-root': {
          color: '#ffffff',
        },
      },
    },
    mantinePaginationProps: {
      sx: {
        background: '#21222D',
        '.mantine-UnstyledButton-root': {
          color: '#ffffff',
          background: '#21222D',
          borderColor: '#CCCCCC',
        },
      },
    },
  })

  useEffect(() => {
    console.log('useEffect 1')
    getSystemLog()
  }, [pageNumber])
  //
  const handlePageNumber = (e, v) => {
    console.log('handlePageNumber v:', v)
    setPageNumber(v)
  }

  useEffect(() => {
    console.log('useEffect 2')
    getServiceLog()
  }, [pageNumber2])
  //
  const handlePageNumber2 = (e, v) => {
    console.log('handlePageNumber2 v:', v)
    setPageNumber2(v)
  }

  const handlePageNumber3 = (e, v) => {
    console.log('handlePageNumber3 v:', v)
    setPageNumber3(v)
  }
  //
  const handlePageNumber4 = (e, v) => {
    console.log('handlePageNumber4 v:', v)
    setPageNumber4(v)
  }

  useEffect(() => {
    console.log('useEffect 3')
    getAuditLog1()
  }, [pageNumber3])

  useEffect(() => {
    console.log('useEffect 4')
    getAuditLog2()
  }, [pageNumber4])

  // useEffect(() => {
  //   console.log('useEffect!!!')
  //   // getServiceLog()
  // }, [pageNumber3])
  // //
  // const handlePageNumber3 = (e, v) => {
  //   console.log('handlePageNumber3 v:', v)
  //   setPageNumber3(v)
  // }
  // useEffect(() => {
  //   console.log('useEffect!!!')
  //   // getServiceLog()
  // }, [pageNumber4])
  // //
  // const handlePageNumber4 = (e, v) => {
  //   console.log('handlePageNumber4 v:', v)
  //   setPageNumber4(v)
  // }

  //시스템로그
  const getSystemLog = async () => {
    try {
      const response = await Api.get(`api/v1/log/system?limit=10&offset=${pageNumber}`)

      if (response.status === 200) {
        setPageNumberTotal(response.data.total_page)
        // setPageNumberTotal(response.data.total)

        setLogList(response.data.logs)
        console.log('getSystemLog ok response.data', response.data)
      }
    } catch (e) {
      console.log('getSystemLog exception', e)
    }
  }
  // mark
  const getSystemLog_for_excel = async () => {
    setLoadingFlagExcel(true)
    try {
      const response = await Api.get(`api/v1/log/system?limit=1000000&offset=0`)

      if (response.status === 200) {
        ExcelExport(response.data.logs, `시스템로그`, { type: 'syslog' })
        console.log('getSystemLog_for_excel ok response.data', response.data)
      }
    } catch (e) {
      setLoadingFlagExcel(false)
      console.log('getSystemLog_for_excel exception', e)
    }
  }

  //서비스로그
  const getServiceLog = async () => {
    try {
      const response = await Api.get(`api/v1/log/service?limit=10&offset=${pageNumber2}`)

      if (response.status === 200) {
        setPageNumberTotal2(response.data.total_page)
        // setPageNumberTotal(response.data.total)

        setLogList2(response.data.logs)
        console.log('getServiceLog ok response.data', response.data)
      }
    } catch (e) {
      console.log('getServiceLog exception', e)
    }
  }
  const getServiceLog_for_excel = async () => {
    setLoadingFlagExcel(true)
    try {
      const response = await Api.get(`api/v1/log/service?limit=1000000&offset=0`)

      if (response.status === 200) {
        ExcelExport(response.data.logs, `서비스로그`, { type: 'servicelog' })
        console.log('getServiceLog_for_excel ok response.data', response.data)
      }
    } catch (e) {
      setLoadingFlagExcel(false)
      console.log('getServiceLog_for_excel exception', e)
    }
  }

  //접속정보로그
  const getAuditLog1 = async () => {
    try {
      const response = await Api.get(`api/v1/audit/?type=1&limit=10&offset=${pageNumber3}`)

      if (response.status === 200) {
        setPageNumberTotal3(response.data.total_page)
        // setPageNumberTotal(response.data.total)

        setLogList3(response.data.audits)
        console.log('getAuditLog1 ok response.data', response.data)
      }
    } catch (e) {
      console.log('getAuditLog1 exception', e)
    }
  }
  const getAuditLog1_for_excel = async () => {
    setLoadingFlagExcel(true)
    try {
      const response = await Api.get(`api/v1/audit/?type=1&limit=1000000&offset=0`)

      if (response.status === 200) {
        ExcelExport(response.data.audits, `접속정보로그`, { type: 'userslog' })
        console.log('getAuditLog1_for_excel ok response.data', response.data)
      }
    } catch (e) {
      setLoadingFlagExcel(false)
      console.log('getAuditLog1_for_excel exception', e)
    }
  }

  //감사로그
  const getAuditLog2 = async () => {
    try {
      const response = await Api.get(`api/v1/audit/?type=2&limit=10&offset=${pageNumber4}`)

      if (response.status === 200) {
        setPageNumberTotal4(response.data.total_page)
        // setPageNumberTotal(response.data.total)

        setLogList4(response.data.audits)
        console.log('getAuditLog2 ok response.data', response.data)
      }
    } catch (e) {
      console.log('getAuditLog2 exception', e)
    }
  }

  const getAuditLog2_for_excel = async () => {
    setLoadingFlagExcel(true)
    try {
      const response = await Api.get(`api/v1/audit/?type=2&limit=1000000&offset=0`)

      if (response.status === 200) {
        ExcelExport(response.data.audits, `감사정보로그`, { type: 'auditlog' })
        console.log('getAuditLog2_for_excel ok response.data', response.data)
      }
    } catch (e) {
      setLoadingFlagExcel(false)
      console.log('getAuditLog2_for_excel exception', e)
    }
  }

  function handleChangePage(event, newpage) {
    setpg(newpage)
  }
  function handleChangeRowsPerPage(event) {
    setrpg(parseInt(event.target.value, 10))
    setpg(0)
  }

  const [value, setValue] = React.useState('1')
  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  const ExcelExport = (data, fileName, excelObject) => {
    console.log('LookupStats 엑셀테스트 data1:', data)
    if (data) {
      exportToExcel()
    }
    // function convertToString(origin, target) {
    //   if (origin.id === target) return [origin.label]
    //   if (!origin.children) return false
    //   let path
    //   const test = origin.children.find((x) => (path = convertToString(x, target)))
    //   //  console.log("test:",test)
    //   if (path) {
    //     return [origin.label].concat(path)
    //   }
    // }

    // function findPathInMeneResult(param) {
    //   let path
    //   data.map((item) => {
    //     return [item].find((x) => (path = convertToString(x, param)))
    //   })
    //   return path
    // }

    //엑셀 해더이름 변환
    function headerList(p1, p2) {
      console.log('headerList p1:', p1)
      console.log('headerList p2:', p2)

      if (nullCheck(p1) === false) {
        let tempList = Object.keys(p1)
        let copyList = [...tempList]
        console.log('headerList copyList1:', copyList)

        if (p2) {
          switch (p2) {
            case 'auditlog':
              copyList.map((item, index) => {
                if (item === 'audit') {
                  copyList[index] = '계정'
                }
                if (item === 'sys') {
                  copyList[index] = '접속시스템'
                }
                if (item === 'fc') {
                  copyList[index] = '기능'
                }
                if (item === 'cdt') {
                  copyList[index] = '감사발생시간'
                }
                if (item === 'tg') {
                  copyList[index] = '감사발생위치(기본파일이름)'
                }
              })
              return [copyList]
            case 'syslog':
              copyList.map((item, index) => {
                if (item === 'udt') {
                  copyList[index] = '날짜'
                }
                if (item === 'cd') {
                  copyList[index] = '타입코드'
                }
                if (item === 'lv') {
                  copyList[index] = '위험도'
                }
                if (item === 'rst') {
                  copyList[index] = '결과'
                }
                if (item === 'fc') {
                  copyList[index] = '기능'
                }
                if (item === 'di') {
                  copyList[index] = '관리자'
                }
                if (item === 'sys') {
                  copyList[index] = '시스템'
                }
                if (item === 'description') {
                  copyList[index] = '내용'
                }
              })
              return [copyList]
            case 'servicelog':
              copyList.map((item, index) => {
                if (item === 'udt') {
                  copyList[index] = '날짜'
                }
                if (item === 'cd') {
                  copyList[index] = '타입코드'
                }
                if (item === 'lv') {
                  copyList[index] = '위험도'
                }
                if (item === 'rst') {
                  copyList[index] = '결과'
                }
                if (item === 'fc') {
                  copyList[index] = '기능'
                }
                if (item === 'di') {
                  copyList[index] = '데이터전송장비'
                }
                if (item === 'sys') {
                  copyList[index] = '시스템'
                }
                if (item === 'description') {
                  copyList[index] = '내용'
                }
              })
              return [copyList]
            case 'userslog':
              copyList.map((item, index) => {
                if (item === 'audit') {
                  copyList[index] = '계정'
                }
                if (item === 'sys') {
                  copyList[index] = '시스템'
                }
                if (item === 'cdt') {
                  copyList[index] = '접속시간'
                }
                if (item === 'edt') {
                  copyList[index] = '종료시간'
                }
                if (item === 'tm') {
                  copyList[index] = '사용시간(시,분,초)'
                }
                if (item === 'tg') {
                  copyList[index] = '접속시스템'
                }
                if (item === 'fc') {
                  copyList[index] = '기능'
                }
              })
              return [copyList]

            default:
              return [copyList]
          }
        }
      }
    }
    function nullCheck(param) {
      if (param !== undefined && param !== null && param !== '') {
        return false
      } else {
        return true
      }
    }

    function convertObject(param) {
      if (nullCheck(param) === false) {
        const convertObject_temp = JSON.stringify(Object.values(param))
        return convertObject_temp
      }
    }

    async function exportToExcel() {
      if (nullCheck(data) === false && data.length > 0) {
        const now = dayjs().format('YYYY-MM-DD HH:mm:ss')
        const loginId = secureLocalStorage.getItem('loginId')

        //copy array of objects and make changes without modifying originam array

        let copyList = data.map((item) => ({ ...item }))

        copyList.map((item) => {
          if (item.hasOwnProperty('wkl')) {
            item['wkl'] = convertObject(item['wkl'])
          }
          if (item.hasOwnProperty('orglists')) {
            item['orglists'] = convertObject(item['orglists'])
          }
          if (item.hasOwnProperty('deviceLists')) {
            item['deviceLists'] = convertObject(item['deviceLists'])
          }
          if (item.hasOwnProperty('orglist')) {
            item['orglist'] = convertObject(item['orglist'])
          }
          if (item.hasOwnProperty('topic_list')) {
            item['topic_list'] = convertObject(item['topic_list'])
          }
          if (item.hasOwnProperty('b_service_list')) {
            item['b_service_list'] = convertObject(item['b_service_list'])
          }
          if (item.hasOwnProperty('dvloc')) {
            delete item['dvloc']
          }
          if (item.hasOwnProperty('detail')) {
            delete item['detail']
          }
          if (item.hasOwnProperty('pw')) {
            delete item['pw']
          }
          if (item.hasOwnProperty('ladt')) {
            delete item['ladt']
          }
          if (item.hasOwnProperty('lgfcnt')) {
            delete item['lgfcnt']
          }
          if (item.hasOwnProperty('lv')) {
            item['lv'] =
              item['lv'] === 1
                ? 'INFO'
                : item['lv'] === 2
                  ? 'WARN'
                  : item['lv'] === 3
                    ? 'DANGER'
                    : item['lv'] === 4
                      ? 'CRIT'
                      : ''
          }
          if (item.hasOwnProperty('rst')) {
            item['rst'] =
              item['rst'] === 1
                ? '성공'
                : item['rst'] === 2
                  ? '실패'
                  : item['rst'] === 3
                    ? '시작'
                    : item['rst'] === 4
                      ? '성공(종료)'
                      : item['rst'] === 5
                        ? '실패(종료)'
                        : ''
          }

          if (item.hasOwnProperty('fc') && excelObject && excelObject.type === 'userslog') {
            item['fc'] = item['fc'] === 1000 ? '접속정보' : ''
          }
          if (item.hasOwnProperty('idx') && excelObject && excelObject.type === 'userslog') {
            delete item['idx']
          }
          if (item.hasOwnProperty('fdesc') && excelObject && excelObject.type === 'userslog') {
            delete item['fdesc']
          }
          if (item.hasOwnProperty('fc') && excelObject && excelObject.type === 'auditlog') {
            item['fc'] = item['fc'] === 1000 ? '접속정보' : item['fc'] === 2000 ? '파일다운로드' : ''
          }
          if (item.hasOwnProperty('idx') && excelObject && excelObject.type === 'auditlog') {
            delete item['idx']
          }
          if (item.hasOwnProperty('fdesc') && excelObject && excelObject.type === 'auditlog') {
            delete item['fdesc']
          }
          if (item.hasOwnProperty('edt') && excelObject && excelObject.type === 'auditlog') {
            delete item['edt']
          }
          if (item.hasOwnProperty('tm') && excelObject && excelObject.type === 'auditlog') {
            delete item['tm']
          }

          if (item.hasOwnProperty('loid') && excelObject && excelObject.type === '안전사고통계조회') {
            delete item['loid']
          }
          if (item.hasOwnProperty('ji') && excelObject && excelObject.type === '안전사고통계조회') {
            delete item['ji']
          }
          if (item.hasOwnProperty('wid') && excelObject && excelObject.type === '안전사고통계조회') {
            delete item['wid']
          }
          if (item.hasOwnProperty('di') && excelObject && excelObject.type === '안전사고통계조회') {
            delete item['di']
          }
        })
        const typeParam = excelObject !== undefined ? excelObject.type : undefined
        let Heading = headerList(copyList[0], typeParam)
        //Had to create a new workbook and then add the header
        const wb = XLSX.utils.book_new()
        const ws = XLSX.utils.json_to_sheet([])
        XLSX.utils.sheet_add_aoa(ws, Heading)
        //Starting in the second row to avoid overriding and skipping headers
        XLSX.utils.sheet_add_json(ws, copyList, { origin: 'A2', skipHeader: true })
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
        XLSX.writeFile(wb, `${fileName}.xlsx`)

        //감사로그
        try {
          const auditObject = {
            cdt: now,
            audit: loginId,
            sys: 'PORTAL',
            fc: '2000',
            tg: fileName,
          }
          const response = await Api.post('/api/v1/audit', auditObject)
          if (response.status === 200) {
            console.log('ExcelExport audit response ok.')
          }
        } catch (e) {
          console.log('ExcelExport catch error:', e)
        }
      }
    }
    setLoadingFlagExcel(false)
  }

  return (
    <TabContext value={value}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <TabList
          sx={{ marginLeft: 3 }}
          TabIndicatorProps={{
            style: {
              display: 'none',
            },
          }}
          onChange={handleChange}
          aria-label="lab API tabs example"
        >
          <StyledTab label="시스템 로그" value="1" />
          <StyledTab label="서비스 로그" value="2" />
          <StyledTab label="접속 정보" value="3" />
          <StyledTab label="감사 정보" value="4" />
        </TabList>
      </Box>
      <TabPanel value="1">
        <Grid container spacing={1}>
          <Grid size={12}>
            <Typography sx={styles1.Typography1}>시스템 로그</Typography>
          </Grid>
          {/* mark */}
          <Grid size={12} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginBottom: 1 }}>
            <div>
              <LoadingButton
                loading={loadingFlagExcel}
                variant="contained"
                sx={{
                  color: '#ffffff',
                  background: '#454546',
                  '.MuiLoadingButton-loadingIndicator': {
                    color: '#ffffff',
                  },
                }}
                onClick={() => getSystemLog_for_excel()}
              >
                <img style={{ width: 25, height: 25 }} src={excel_img}></img>
                &nbsp;엑셀 내보내기
              </LoadingButton>
            </div>
          </Grid>
          <Grid size={12}>
            <div>
              <MantineReactTable table={table} />
              <Box sx={{ justifyItems: 'center', alignItems: 'center', marginTop: 2 }}>
                <Stack spacing={2}>
                  <MyPagination
                    count={pageNumberTotal}
                    variant="outlined"
                    shape="rounded"
                    onChange={(event, page) => handlePageNumber(event, page)}
                  />
                </Stack>
              </Box>
            </div>
          </Grid>
        </Grid>
      </TabPanel>
      <TabPanel value="2">
        <Grid container spacing={1}>
          <Grid size={12}>
            <Typography sx={styles1.Typography1}>서비스 로그</Typography>
          </Grid>
          <Grid size={12} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginBottom: 1 }}>
            <LoadingButton
              loading={loadingFlagExcel}
              variant="contained"
              sx={{
                color: '#ffffff',
                background: '#454546',
                '.MuiLoadingButton-loadingIndicator': {
                  color: '#ffffff',
                },
              }}
              onClick={() => getServiceLog_for_excel()}
            >
              <img style={{ width: 25, height: 25 }} src={excel_img}></img>
              &nbsp;엑셀 내보내기
            </LoadingButton>
          </Grid>
          <Grid size={12}>
            <div>
              <MantineReactTable table={table2} />
              <Box sx={{ justifyItems: 'center', alignItems: 'center', marginTop: 2 }}>
                <Stack spacing={2}>
                  <MyPagination
                    count={pageNumberTotal2}
                    variant="outlined"
                    shape="rounded"
                    onChange={(event, page) => handlePageNumber2(event, page)}
                  />
                </Stack>
              </Box>
            </div>
          </Grid>
        </Grid>
      </TabPanel>
      <TabPanel value="3">
        <Grid container spacing={1}>
          <Grid size={12}>
            <Typography sx={styles1.Typography1}>접속 정보 로그</Typography>
          </Grid>
          <Grid size={12} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginBottom: 1 }}>
            <LoadingButton
              loading={loadingFlagExcel}
              variant="contained"
              sx={{
                color: '#ffffff',
                background: '#454546',
                '.MuiLoadingButton-loadingIndicator': {
                  color: '#ffffff',
                },
              }}
              onClick={() => getAuditLog1_for_excel()}
            >
              <img style={{ width: 25, height: 25 }} src={excel_img}></img>
              &nbsp;엑셀 내보내기
            </LoadingButton>
          </Grid>
          <Grid size={12}>
            {' '}
            <div>
              <MantineReactTable table={table3} />
              <Box sx={{ justifyItems: 'center', alignItems: 'center', marginTop: 2 }}>
                <Stack spacing={2}>
                  <MyPagination
                    count={pageNumberTotal3}
                    variant="outlined"
                    shape="rounded"
                    onChange={(event, page) => handlePageNumber3(event, page)}
                  />
                </Stack>
              </Box>
            </div>
          </Grid>
        </Grid>
      </TabPanel>
      <TabPanel value="4">
        <Grid container spacing={1}>
          <Grid size={12}>
            <Typography sx={styles1.Typography1}>감사 정보 로그</Typography>
          </Grid>
          <Grid size={12} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginBottom: 1 }}>
            <LoadingButton
              loading={loadingFlagExcel}
              variant="contained"
              sx={{
                color: '#ffffff',
                background: '#454546',
                '.MuiLoadingButton-loadingIndicator': {
                  color: '#ffffff',
                },
              }}
              onClick={() => getAuditLog2_for_excel()}
            >
              <img style={{ width: 25, height: 25 }} src={excel_img}></img>
              &nbsp;엑셀 내보내기
            </LoadingButton>
          </Grid>
          <Grid size={12}>
            <div>
              <MantineReactTable table={table4} />
              <Box sx={{ justifyItems: 'center', alignItems: 'center', marginTop: 2 }}>
                <Stack spacing={2}>
                  <MyPagination
                    count={pageNumberTotal4}
                    variant="outlined"
                    shape="rounded"
                    onChange={(event, page) => handlePageNumber4(event, page)}
                  />
                </Stack>
              </Box>
            </div>
          </Grid>
        </Grid>
      </TabPanel>
    </TabContext>
  )
}
